import React from 'react';
import { unreachable } from '../../../ts-utils';
import { RootBoxEffectContext } from './root-box-effect-context';
import { getViewportCenterY, findClosestBox, focusWithRetry, } from './root-box-effect-provider.utils';
import { isOffScreen } from '../../../common/utils/is-off-screen';
export const RootBoxEffectProvider = ({ effectState, children, }) => {
    const [boxRegistry] = React.useState(new Map());
    const closeAll = () => {
        boxRegistry.forEach((box) => box.close());
    };
    const expandClosest = (options) => {
        if (boxRegistry.size > 0) {
            const centerY = getViewportCenterY();
            const closest = findClosestBox(boxRegistry, centerY);
            if (!closest) {
                return;
            }
            const { shouldScroll, shouldFocus } = options;
            const maybeScroll = () => {
                const waitUntilOnScreen = (resolve) => {
                    isOffScreen(closest.node)
                        ? setTimeout(() => {
                            waitUntilOnScreen(resolve);
                        }, 250)
                        : resolve(null);
                };
                return new Promise((resolve) => {
                    if (!shouldScroll || !isOffScreen(closest.node)) {
                        return resolve(null);
                    }
                    closest.node.scrollIntoView({ behavior: 'smooth', block: 'center' });
                    waitUntilOnScreen(resolve);
                });
            };
            closest
                .expand({ autoFocus: false })
                .then(() => maybeScroll())
                .then(() => shouldFocus && focusWithRetry(closest.focus));
        }
    };
    React.useEffect(() => {
        if (effectState) {
            switch (effectState.type) {
                case 'open':
                    const { shouldFocus, shouldScroll } = effectState;
                    expandClosest({ shouldFocus, shouldScroll });
                    return;
                case 'close':
                    closeAll();
                    return;
                default:
                    unreachable(effectState);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [effectState]);
    return (React.createElement(RootBoxEffectContext.Provider, { value: React.useMemo(() => ({
            optIn: ({ position, box }) => {
                boxRegistry.set(position, box);
            },
            optOut: (position) => {
                boxRegistry.delete(position);
            },
        }), [boxRegistry]) }, children));
};
export default RootBoxEffectProvider;
//# sourceMappingURL=root-box-effect-provider.js.map